import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RestBuilder } from '../helpers/rest.builder';
import { LoaderService } from '../loader.service';
import {
  ClientInstrumentationEventType,
  IClientInstrumentationRequest,
  IClientProps,
} from '../../../../shared/interfaces/client-instrumentation.interface';

@Injectable({
  providedIn: 'root',
})
export class InstrumentationApi {
  private readonly restBuilder: RestBuilder = new RestBuilder();

  constructor(
    private httpClient: HttpClient,
    private loaderService: LoaderService,
  ) {}

  public instrument(
    eventName: ClientInstrumentationEventType,
    eventProps: IClientProps,
    workspaceId?: string,
    digitalPropertyId?: string,
  ): Observable<void> {
    const request: IClientInstrumentationRequest = {
      type: eventName,
      eventProps,
      workspaceId,
      digitalPropertyId,
    };
    const apiUrl: string = this.restBuilder.create().instrument().getApiUrl();
    this.loaderService.skipNext();
    return this.httpClient.post<void>(apiUrl, request);
  }
}
